let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5GFyb")).then(() => parcelRequire('jiVgR'));